import type {RuleValidationErrors} from '../types';
import {FileAspectType, FileAspectOrientationValue} from './constants';
import type {FileAspectRule} from './types';
import {createValidationObject} from '../../utils/createValidationObject';

export const validateFileAspectRule = <
	T extends FileAspectRule = FileAspectRule,
>(
	rule: T,
): RuleValidationErrors | false => {
	if (
		rule.elementSubType1 === FileAspectType.ORIENTATION &&
		![
			FileAspectOrientationValue.LANDSCAPE,
			FileAspectOrientationValue.PORTRAIT,
		].includes(rule.elementValue1)
	) {
		return {
			elementValue1: createValidationObject(),
		};
	}

	if (rule.elementValue1.toString() === '')
		return {
			elementValue1: createValidationObject(),
		};

	return false;
};

export default validateFileAspectRule;
